import { SummaryList, Tag } from 'nhsuk-react-components';
import { JSX } from 'react';
import { Link } from 'react-router-dom';

interface SummaryRowProps {
  itemName: string;
  itemKey: string;
  itemValue: string | JSX.Element | undefined;
  canUpdate: boolean;
  handleEdit?: (path: string) => void;
}

export default function SummaryRow({
  itemName,
  itemKey,
  itemValue,
  handleEdit,
  canUpdate,
}: SummaryRowProps) {
  return (
    <SummaryList.Row key={itemKey} className="summary-row">
      <SummaryList.Key>{itemName}</SummaryList.Key>
      <SummaryList.Value test-id={`summaryrow-value-${itemKey}`}>
        {itemValue || <Tag modifier="red">To complete</Tag>}
      </SummaryList.Value>
      {canUpdate && (
        <SummaryList.Action>
          <Link
            onClick={(e) => {
              e.preventDefault();
              if (handleEdit) {
                handleEdit('');
              }
            }}
            state={{ editMode: true }}
            test-id={`summaryrow-update-${itemKey}`}
            aria-label={`Edit ${itemName}`}
            to="#"
          >
            Edit
          </Link>
        </SummaryList.Action>
      )}
    </SummaryList.Row>
  );
}
